<template>
	<div>
		<div v-loading="loading">
			<div class="bg" v-if="isgenerate">
				<div class="small-tip">{{ tipText }}</div>
				<div class="list">
					<data-list
						:columns="columns"
						:data="adCampaignVoList"
						@valueChanged="valueChanged"
						:table-style="{ name: 'webclient' }"
					>
					</data-list>
					<data-list
						:columns="adGroupColumns"
						:data="adGroupdata"
						class="adGroup"
						:table-style="{ name: 'webclient' }"
						@valueChanged="valueChangedtwo"
					>
					</data-list>
				</div>
			</div>
			<generatePage v-if="!isgenerate" :type="type" :name="name"></generatePage>
			<div>
				<client-module class="preview" moduletitle="账户结构预览">
					<ads-preview
						:adCustomerAssetVo="adCustomerAssetVo"
						:adCampaignVoList="adCampaignVoList"
					></ads-preview>
				</client-module>
			</div>
		</div>
		<wordDialog
			:dialogVisible.sync="wordVisible"
			:adGroupId="adGroupId"
			:wordName="wordName"
			@success="addSuccess"
		></wordDialog>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import adsPreview from './ads-preview';
import bid from './Bid';
import languageEdit from './languageEdit';
import generatePage from '@/components/accountOnline/generatePage';
import wordDialog from '@/components/accountOnline/wordDialog';
import searchText from '@/components/iglobalwin/dataList/searchText';
export default {
	props: {
		type: {
			type: Number,
		},
		name: { type: String },
		isgenerate: null,
	},
	data() {
		let that = this;
		return {
			tipType: null,
			isCountry:
				'客户有重点投放国家/地区，因此将创建两个广告系列：“全球”“重点国家”，并为每个推广产品创建一个广告组',
			noCountry:
				'客户没有重点投放国家/地区，将创建一个广告系列；并为每个核心推广产品创建一个广告组',
			columns: [
				{
					label: '广告系列名称',
					bind: 'campainName',
					type: 'editInput',
					size: 'medium',
					minWidth: 160,
					change: (val, scope) => {
						if (val) {
							let param = {
								id: scope.row.id,
								name: val,
							};
							that.update(param, 0);
						}
					},
				},
				{
					label: '日预算',
					placeholder: '批量设置预算',
					minWidth: 165,
					bind: 'amountMicros',
					type: 'editInput',
					number: true,
					min: 0,
					max: 1000000,
					controls: false,
					change: (val, scope) => {
						let param = {
							id: scope.row.id,
							price: val,
						};
						that.update(param, 0);
					},
					customize: true,
					columnsType: searchText,
				},
				{
					label: '定位',
					type: 'custInfo',
					minWidth: 160,
					text: [
						{
							bind: 'location',
						},
					],
					formatter(item, row) {
						return row[item.bind] && row[item.bind].length ? row[item.bind].toString() : '-';
					},
				},
				{
					label: '排除',
					type: 'custInfo',
					minWidth: 160,
					text: [
						{
							bind: 'exclude',
						},
					],
					formatter(item, row) {
						return row[item.bind] && row[item.bind].length ? row[item.bind].toString() : '-';
					},
				},
				{
					label: '出价策略类型',
					bind: 'biddingStrategyType',
					minWidth: 200,
				},
				{
					label: '投放网络',
					bind: 'advertisingChannelType',
					minWidth: 300,
				},
				{
					label: '语言',
					bind: 'languages',
					minWidth: 150,
					type: languageEdit,
					state: that.type,
					change() {
						that.getData();
					},
					typeVal: 0,
				},
				{
					label: '广告组系列设备出价调整',
					bind: 'deviceCriteriaInfoVos',
					minWidth: 190,
					type: bid,
					state: that.type,
					change() {
						that.getData();
					},
					typeVal: 0,
				},
				{
					label: '默认启用状态',
					bind: 'status',
					type: 'listSwitch',
					activeValue: 1,
					inactiveValue: 0,
					disabled: false,
					change: (val, scope) => {
						let param = {
							id: scope.row.id,
							status: val,
						};
						that.update(param, 0);
					},
				},
			],
			adCampaignVoList: [],
			adGroupColumns: [
				{
					label: '广告组名称',
					bind: 'adGroupName',
					type: 'editInput',
					size: 'medium',
					minWidth: 380,
					change: (val, scope) => {
						if (val) {
							let param = {
								id: scope.row.id,
								name: val,
							};
							that.update(param, 1);
						}
					},
				},
				{
					label: '所属广告系列',
					minWidth: 165,
					bind: 'campaignName',
				},
				{
					label: '出价',
					placeholder: '批量设置出价',
					minWidth: 165,
					bind: 'cpcBidMicros',
					type: 'editInput',
					number: true,
					min: 0,
					max: 1000000,
					controls: false,
					change: (val, scope) => {
						let param = {
							id: scope.row.id,
							price: val,
						};
						that.update(param, 1);
					},
					customize: true,
					columnsType: searchText,
				},
				{
					label: '广告组设备出价调整',
					bind: 'deviceCriteriaInfoVos',
					minWidth: 180,
					type: bid,
					state: that.type,
					change() {
						that.getData();
					},
					typeVal: 1,
				},
				{
					label: '默认启用状态',
					bind: 'status',
					type: 'listSwitch',
					activeValue: 1,
					inactiveValue: 0,
					disabled: false,
					minWidth: 130,
					change: (val, scope) => {
						let param = {
							id: scope.row.id,
							status: val,
						};
						that.update(param, 1);
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					minWidth: 160,
					bind() {
						let arr = [
							{
								text: '创建厂家词广告组',
								trigger(row) {
									that.wordVisible = true;
									that.adGroupId = row.id;
									that.wordName = row.adGroupName;
								},
								showButton(row) {
									return !row.parentId&&row.isManufacturerWord==0;
								},
							},
							{
								text: '删除',
								trigger(row) {
									that.deleteManufactureWord(row.id);
								},
								showButton(row) {
									return row.parentId;
								},
							},
						];

						return arr;
					},
				},
			],
			adGroupdata: [],
			adCustomerAssetVo: {},
			loading: false,
			butttonloading: false,
			butText: '确认无误，一键搭建账户',
			timer: null,
			searchStatus: null,
			wordVisible: false,
			adGroupId: '',
			wordName: '',
		};
	},

	components: { clientModule, adsPreview, generatePage, wordDialog },

	computed: {
		queryParam() {
			return this.$route.query;
		},
		tipText() {
			if (this.type == 0) {
				return '将为每个核心推广产品创建一个广告系列，每个广告系列下包含一个广告组';
			} else {
				return this.tipType == 2 ? this.isCountry : this.noCountry;
			}
		},
	},
	watch: {
		type: {
			handler(val) {
				this.loading = true;
				// this.AddData().then(res => {
				// 	if (res) {
				this.getData();
				// 	}
				// });
			},
			immediate: true,
		},
	},

	methods: {
		async getData() {
			// try {
			let res = await adsNewOnlineSer.get_ads({
				...this.queryParam,
				type: this.type,
			});

			this.tipType = res.data.type;
			this.loading = false;
			//广告系列
			this.adCampaignVoList = res.data.adCampaignVoList;
			let arr1 = [];
			if (res.data.adGroupVos && res.data.adGroupVos.length) {
				let arr = res.data.adGroupVos.filter(e => {
					return e.parentId;
				});
				 arr1 = res.data.adGroupVos.filter(e => {
					
					return e.parentId==null;
				});
				for (let i = 0; i < arr.length; i++) {
					for (let j = 0; j < arr1.length; j++) {
						if (arr1[j].id == arr[i].parentId) {
							arr1.splice(j + 1, 0, arr[i]);
						}
					}
				}
			}
			this.adGroupdata = arr1;
			this.adCustomerAssetVo = res.data.adCustomerAssetVo; //预览数据
			// } catch (error) {
			// 	this.loading = false;
			// }
		},
		async update(param, type) {
			let res = await adsNewOnlineSer.update_ads(
				{
					...param,
					state: this.type, //0,核心推广产品;1,国家/地区
				},
				{ type: type } ///0,广告系列;1,广告组
			);
			if (res.data) {
				this.$message({
					message: '修改成功',
					type: 'success',
				});
				this.getData();
			} else {
				this.$message.error({
					message: '修改失败',
				});
			}
		},
		//批量修改
		valueChanged(val) {
			let param = {
				automationId: this.queryParam.automationId,
				price: val,
			};
			this.update(param, 0);
		},
		//批量修改
		valueChangedtwo(val) {
			let param = {
				automationId: this.queryParam.automationId,
				price: val,
			};
			this.update(param, 1);
		},
		async AddData() {
			let res = await adsNewOnlineSer.add_ads(
				{ automationId: this.queryParam.automationId },
				{ serviceSiteId: this.queryParam.serviceSiteId }
			);
			return res.data;
		},
		addSuccess() {
			this.getData();
		},
		async deleteManufactureWord(id) {
			if (id) {
				let res = await adsNewOnlineSer.deleteManufactureWord({ adGroupId: id });
				if (res.data == 'success') {
					this.$message({
						message: '删除厂家词广告组成功',
						type: 'success',
					});
					this.getData();
				}
			}
		},
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.bg {
	background: #ffffff;
}
.small-tip {
	font-size: 14px;
	font-weight: 400;
	color: #999999;
	margin: 0px 0px 20px 30px;
}
.list {
	background: #ffffff;
	padding: 0px 20px;
}
.adGroup {
	margin-top: 20px;
}
.preview {
	background: #ffffff;
	height: auto;
	margin-top: 10px;
}
.bottom {
	text-align: right;
	line-height: 70px;
	margin-top: 20px;
	height: 70px;
	padding-right: 50px;
	background: #ffffff;
	box-shadow: 0px -4px 4px 0px rgba(51, 51, 51, 0.05);
}
</style>
